export default __webpack_public_path__ + "img/arrow-down-m.2cb3ebef.svg";